import { CircularProgress, Modal } from '@material-ui/core'
import React from 'react'

interface ModalProps {
	loading: boolean
}

export const DefaultLoaderModal: React.FC<ModalProps> = (props: ModalProps) => (
	<Modal aria-labelledby="simple-loading-modal" open={props.loading} disableAutoFocus={true}>
		<CircularProgress
			style={{ position: 'absolute', top: '50%', left: '50%', marginTop: '-20px', marginLeft: '-20px', color: 'white' }}
			size={50}
		/>
	</Modal>
)

export default DefaultLoaderModal
